export default __webpack_public_path__ + "static/media/zlxmmc.a5713062.jpg";